import { render, staticRenderFns } from "./NotFoundMessage.vue?vue&type=template&id=049861f6&scoped=true&"
import script from "./NotFoundMessage.vue?vue&type=script&lang=js&"
export * from "./NotFoundMessage.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundMessage.vue?vue&type=style&index=0&id=049861f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049861f6",
  null
  
)

export default component.exports